export default [
  {
    path: '/general/fuxi-view',
    meta: {
      title: '伏羲低码预览页面',
      hiddenBreadCrumb: true,
      menuRender: false,
    },
    component: () => import('./index'),
  },
]
